import React, { useEffect } from 'react';
import { Spinner, SpinnerSize } from '@amzn/stencil-react-components/spinner';
import {usePrincipal, saveCookies } from '../../hooks';
import { useGetContactInfoQuery } from '../../services/invite';
import WelcomeContentView from './WelcomeContentView';
import Footer from './Footer';
import ContactHelpErrorBoundary from './ContactHelpErrorBoundary';
import '../.././styles/alumni.scss';
import { recordEvent } from 'src/analytics/amplify';
import ReactRoutes from "src/constants/react-routes";
import {useSearchParams} from "react-router-dom";
import {useNavigate} from "react-router";
import {showNewActivationFlow} from "src/constants/feature-gates";

export default function WelcomeScreen() {
    saveCookies();
    const [principal] = usePrincipal();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const code = searchParams.get('code') || ''
    const { isLoading, error } = useGetContactInfoQuery({principal, code});
    let isLinkValid = true;
    if (error) {
        if (showNewActivationFlow() &&
            (error as any)?.status === 401 && (error as any)?.data.message.includes('Activation code')) {
            isLinkValid = false;
        }
    }
    useEffect(() => {
        if (!isLinkValid) {
            navigate({pathname: ReactRoutes.ALUMNI_ERROR_SCREEN, search: searchParams.toString()});
        }
        recordEvent({
            name: 'WelcomeScreen.Render',
        });
    }, [isLinkValid, navigate]);
    
    return (
        <ContactHelpErrorBoundary>
            <div className="fullscreen">
                <div className="flex-container">
                    <div className="flex-box-right">
                        <div data-testid="welcomeContent" className="content-wrap">
                            { isLoading ? <Spinner data-testid="welcomeSpinner" size={SpinnerSize.Medium} /> :
                                (isLinkValid && <WelcomeContentView />)
                            }
                        </div>
                        <div data-testid="footer" className="footer-container">
                            <Footer screen="WelcomeScreen"/>
                        </div>
                    </div>
                </div>
            </div>
        </ContactHelpErrorBoundary>
    );
}
